import { Country, State } from 'country-state-city';
import React, { useState, useEffect } from 'react';
import currencyCodes from 'currency-codes';
import { addDays } from 'date-fns'; // Import date-fns for date manipulation
import ErrorAlert from '../../../common/Alert/ErrorAlert';
import SuccessAlert from '../../../common/Alert/SuccessAlert';
import { connect } from 'react-redux';
import { validatedEmail, validatedMobile } from '../../../../utils/InputValidation';
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import $ from 'jquery';

const identity_host = process.env.REACT_APP_IDENTITY_HOST;
var iti1 = null;
var iti2 = null;

function IndividualSale({ saleContext, saleType, csrf }) {

    // Learner details
    const [learnerDetails, setLearnerDetails] = useState({ 
        name: "",
        leadEmail: "",
        enrollmentEmail: "",
        enrollmentEmailAsLeadEmail: false,
        paymentEmailAsLeadEmail: false,
        phoneNumber: "",
        secondaryPhoneNumber: "",
        country: "India",
        countryCode: "IN",
        state: "",
        paymentEmail: "",
        isBusiness: false,
        gstNumber: "",
        companyName: "",
        companyAddress: ""
    });

    const paymentTypeOptions = ["Full Payment", "Installments", "Down Payment"];
    const [paymentType, setPaymentType] = useState("");

    const [program, setProgram] = useState("");
    const [BOGOProgram, setBOGOProgram] = useState("");
    const [salePrice, setSalePrice] = useState("");
    const [discount, setDiscount] = useState("");
    const [offerType, setOfferType] = useState("");
    const [saleOwnerEmail, setSaleOwnerEmail] = useState("");
    const [teamLeadEmail, setTeamLeadEmail] = useState("");
    const [accessStartDate, setAccessStartDate] = useState("");
    const [accessEndDate, setAccessEndDate] = useState(""); 
    const [mrp, setMrp] = useState("");
    const [salePriceError, setSalePriceError] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const [paymentGateway, setPaymentGateway] = useState("");
    const [paymentDate, setPaymentDate] = useState("");
    const [accessDays, setAccessDays] = useState(7);
    const [currency, setCurrency] = useState("USD");
    const [amountReceived, setAmountReceived] = useState("");


    const [iserror, setIsError] = useState(false);
    const [issuccess, setIsSuccess] = useState(false);
    const [message, setMessage] = useState("");

    // Installment details
    const [installments, setInstallments] = useState([
        { 
            id: 1, 
            installment_number: "installment_1",
            dueAmount: "", 
            dueDate: "", 
            status: "received",  
            receivedInstallmentAmount: "",
            paymentDate: "",
            transactionId: "",
            paymentGateway: "",
            startDate: "",
            expiryDate: "",
            validityOption: "7_days",
            accessDays: 7,
            expiryDateError: "",
            startDateError: "",
            dueAmountError: "",
            receivedAmountError: ""
        }
    ]);
    const [receivedAmountError, setReceivedAmountError] = useState("");
    const [validityOption, setValidityOption] = useState("7_days");
    const [startDateError, setStartDateError] = useState(""); 
    const [expiryDateError, setExpiryDateError] = useState(""); 

    // Loan details
    const [loanDetails, setLoanDetails] = useState({
        loanPartner: "",
        loanAmount: "",
        loanStatus: "pending"
    });


    // Get the offer name based on the selected offer type
    const selectedOfferName = saleContext?.offer_type?.find(
        (offer) => offer.id === parseInt(offerType)
    )?.name;    

    // Get the program access duration based on the selected program
    const programAccessDuration = saleContext?.programs?.find(
        (p) => p.id === parseInt(program?.split("-")[0])
    )?.access_duration;

    useEffect(()=>{
        const input = document.getElementById("phoneNumber");
        const input2 = document.getElementById("secondaryPhoneNumber");
        if(input){
          iti1 = intlTelInput(input, {
            allowDropdown: true,
            autoHideDialCode: true,
            initialCountry:"IN",
            preferredCountries: ["in", "us"],
          });
        }
        if(input2){
          iti2 = intlTelInput(input2, {
            allowDropdown: true,
            autoHideDialCode: true,
            initialCountry:"IN",
            preferredCountries: ["in", "us"],
          });
        }
    },[])

    /**
     * Handles changes to the Sale Price field.
     * Ensures the Sale Price does not exceed the MRP.
     * Automatically calculates the discount based on MRP and Sale Price.
     * Updates the amount due based on the received amount.
     */
    const handleSalePriceChange = (value) => {
        const numericValue = parseFloat(value);
        const received = parseFloat(amountReceived) || 0;
        if (isNaN(numericValue)) {
            setSalePrice(""); 
            setSalePriceError("");
            setLoanDetails(prev => ({ ...prev, loanAmount: "" }));
            return;
        }
        if (mrp && numericValue > parseFloat(mrp)) {
            setSalePriceError("Sale Price cannot be greater than MRP.");
        } else {
            setSalePriceError("");
            setSalePrice(numericValue);
            if (mrp) {
                setDiscount(parseFloat(mrp) - numericValue);
            }

            if (paymentType === "Down Payment") {
                const loan = numericValue - received;
                setLoanDetails(prev => ({
                    ...prev,
                    loanAmount: loan 
                }));
            }
        }
    };

    /**
     * Handles changes to the Received Amount field.
     * Automatically updates the amount due based on the sale price.
     * Ensures the received amount does not exceed the sale price.
     */
    const handleReceivedAmountChange = (value) => {
        const numericValue = parseFloat(value);
        const numericSalePrice = parseFloat(salePrice || 0);
    
        if (isNaN(numericValue)) {
            setAmountReceived("");
            setReceivedAmountError("");
            setLoanDetails(prev => ({ ...prev, loanAmount: "" }));
            return;
        }
    
        if (numericValue > numericSalePrice) {
            setReceivedAmountError("Received Amount cannot be greater than Sale Price.");
        } 
        else if (paymentType === "Full Payment" && numericValue !== numericSalePrice) {
            setReceivedAmountError("Received Amount must equal Sale Price.");
        }
        else if (paymentType === "Down Payment" && numericValue === numericSalePrice) {
            setReceivedAmountError("Received Amount cannot equal Sale Price.");
        }
        else {
            setReceivedAmountError("");
        }
        setAmountReceived(numericValue);

        if (paymentType === "Down Payment") {
            const loan = numericSalePrice - numericValue;
            setLoanDetails(prev => ({
                ...prev,
                loanAmount: loan
            }));
        }
    };    

    /**
     * Handles changes to the MRP field.
     * Automatically calculates the discount based on MRP and Sale Price.
     */
    const handleMrpChange = (value) => {
        const numericValue = parseFloat(value);
        if (isNaN(numericValue)) {
            setMrp("");
            setDiscount("");
            return;
        }
        setMrp(numericValue);
        if (salePrice) {
            setDiscount(numericValue - parseFloat(salePrice));
        }
    };

    /**
     * Handles changes to the Start Date field.
     * Automatically calculates the Expiry Date based on the Start Date and Validity.
     * Ensures the Start Date is not in the past.
     */
    const handleStartDateChange = (value) => {
        const today = new Date().setHours(0, 0, 0, 0); // Today's date without time
        const selectedDate = new Date(value).setHours(0, 0, 0, 0);

        if (selectedDate < today) {
            setStartDateError("Start Date cannot be in the past.");
            setAccessStartDate("");
            return;
        } else {
            setStartDateError("");
        }

        setAccessStartDate(value);
        if (value && accessDays) {
            const expiryDate = addDays(new Date(value), parseInt(accessDays, 10));
            setAccessEndDate(expiryDate.toISOString().split('T')[0]); // Format as YYYY-MM-DD
        } else {
            setAccessEndDate("");
        }
    };

    /**
     * Handles changes to the Validity field.
     * Updates the Expiry Date based on the Start Date and Validity.
     */
    const handleValidityChange = (value) => {
        setValidityOption(value);
        let days = 0;
        if (value === "7_days") {
            days = 7;
        } 
        else if (value === "1_month") {
            days = 30;
        } 
        else if (value === "full_access") { 
            days = programAccessDuration;
        }        
        setAccessDays(days);
        if (accessStartDate && days) {
            const expiryDate = addDays(new Date(accessStartDate), days);
            setAccessEndDate(expiryDate.toISOString().split('T')[0]); // Format as YYYY-MM-DD
        } else if (value === "custom") {
            setAccessDays(""); 
            setAccessEndDate(""); 
        }
    };

    /**
     * Handles changes to the Expiry Date field.
     * Automatically calculates the Validity (accessDays) based on the Start Date and Expiry Date.
     * Ensures the Expiry Date is not less than or equal to the Start Date.
     */
    const handleExpiryDateChange = (value) => {
        if (accessStartDate) {
            const startDate = new Date(accessStartDate).setHours(0, 0, 0, 0);
            const endDate = new Date(value).setHours(0, 0, 0, 0);

            if (endDate <= startDate) {
                setExpiryDateError("Expiry Date cannot be the same as or earlier than the Start Date.");
                setAccessEndDate("");
                return;
            } else {
                setExpiryDateError(""); 
            }
        }

        setAccessEndDate(value);
        if (accessStartDate && value) {
            const startDate = new Date(accessStartDate);
            const endDate = new Date(value);
            const days = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
            setAccessDays(days);
            if (days === 7) setValidityOption("7_days");
            else if (days === 30) setValidityOption("1_month");
            else if (programAccessDuration && days === programAccessDuration) setValidityOption("full_access");
            else setValidityOption("custom");
        } else {
            setAccessDays(""); 
        }
    };

    // Adds a new installment to the list of installments.
    const addInstallment = () => {
        setInstallments([
            ...installments,    
            { 
                id: installments.length + 1, 
                installment_number: "installment_" + (installments.length + 1),
                dueAmount: "", 
                dueDate: "", 
                status: "due",
                receivedInstallmentAmount: "",
                paymentDate: "",
                transactionId: "",
                paymentGateway: "",
                startDate: "",
                expiryDate: "",
                validityOption: "7_days",
                accessDays: 7,
                expiryDateError: "",
                startDateError: "",
                dueAmountError: "",
                receivedAmountError: ""
            }
        ]);
    };

    const removeInstallment = (indexToRemove) => {
        setInstallments((prev) => {
            const updated = prev.filter((_, index) => index !== indexToRemove);
            return updated.map((inst, idx) => ({
                ...inst,
                id: idx + 1,
                installment_number: "installment_" + (idx + 1),
            }));
        });
    };    

    /**
     * Updates a specific field of an installment.
     * @param {number} index - The index of the installment to update.
     * @param {string} field - The field to update.
     * @param {any} value - The new value for the field.
     */

    const updateInstallment = (index, field, value) => {
        const updatedInstallments = [...installments];
        const installment = { ...updatedInstallments[index], [field]: value };
    
        const today = new Date().setHours(0, 0, 0, 0);

        if (field === "startDate") {
            const selectedDate = new Date(value).setHours(0, 0, 0, 0);
    
            if (selectedDate < today) {
                installment.startDateError = "Start Date cannot be in the past.";
                installment.startDate = "";
                installment.expiryDate = "";
            } else {
                installment.startDateError = "";
                installment.startDate = value;
    
                const days = parseInt(installment.accessDays, 10);
                if (days) {
                    const expiryDate = addDays(new Date(value), days);
                    installment.expiryDate = expiryDate.toISOString().split('T')[0];
                }
            }
        }
    
        else if (field === "validityOption") {
            let days = 0;
            if (value === "7_days") days = 7;
            else if (value === "1_month") days = 30;
            else if (value === "full_access") {
                days = programAccessDuration
            }
    
            installment.validityOption = value;
            installment.accessDays = days;
    
            if (installment.startDate && days) {
                const expiryDate = addDays(new Date(installment.startDate), days);
                installment.expiryDate = expiryDate.toISOString().split('T')[0];
            } else if (value === "custom") {
                installment.accessDays = "";
                installment.expiryDate = "";
            }
        }
    
        else if (field === "expiryDate") {
            const startDate = new Date(installment.startDate).setHours(0, 0, 0, 0);
            const endDate = new Date(value).setHours(0, 0, 0, 0);
    
            if (endDate <= startDate) {
                installment.expiryDateError = "Expiry Date cannot be same or earlier than Start Date.";
                installment.expiryDate = "";
            } else {
                installment.expiryDateError = "";
                installment.expiryDate = value;
    
                const days = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
                installment.accessDays = days;
    
                if (days === 7) installment.validityOption = "7_days";
                else if (days === 30) installment.validityOption = "1_month";
                else if (programAccessDuration && days === programAccessDuration) installment.validityOption = "full_access";
                else installment.validityOption = "custom";
            }
        }

        else if (field === "accessDays") {
            installment.accessDays = value;
        
            const days = parseInt(value, 10);
            if (installment.startDate && days > 0) {
                const expiryDate = addDays(new Date(installment.startDate), days);
                installment.expiryDate = expiryDate.toISOString().split('T')[0];
            } else {
                installment.expiryDate = "";
            }
        }    
        
        else if (field === "receivedInstallmentAmount") {
            const amount = parseFloat(value);
            const due = parseFloat(installment.dueAmount || 0);
            const sale = parseFloat(salePrice || 0);
        
            installment.receivedInstallmentAmount = value;
            installment.receivedAmountError = isNaN(amount) ? "" : amount > sale ? "Received Amount cannot exceed Sale Price." : amount !== due ? "Received Amount must equal Due Amount." : "";
        }              

        else if (field === "dueAmount") {
            const due = parseFloat(value);
            const sale = parseFloat(salePrice || 0);
            installment.dueAmount = value;
            installment.dueAmountError = (!isNaN(due) && due > sale) ? "Due Amount cannot exceed Sale Price." : "";
        }       
    
        else {
            installment[field] = value;
        }
    
        updatedInstallments[index] = installment;
        setInstallments(updatedInstallments);
    };

    // Handles the form submission for creating a sale.
    const createSale = async (event) => {
        event.preventDefault();
        console.log('createSale function called');

        let country_code = '+'+iti1.getSelectedCountryData().dialCode;
        let secondary_country_code = '+'+iti2.getSelectedCountryData().dialCode;

        const email_ids = ['#enrollmentEmail', '#leadEmail', '#paymentEmail'];
        for (let id of email_ids) {
            const email = $(id).val();
            if (email && !validatedEmail(email)) {
                $('.warning-danger').remove();
                $(id).parent().append('<p class="warning-danger w-100 mt-2 fs-13">Enter a valid email id</p>');
                setTimeout(() => {
                $('.warning-danger').slideUp(500, 'linear', () => $(this).remove());
                }, 2000);
                return;
            }
        }

        const num_ids = ['#phoneNumber', '#secondaryPhoneNumber'];
        for (let id of num_ids) {
            const num = $(id).val();
            if (num && !validatedMobile(num)) {
                $('.warning-danger').remove();
                $(id).closest('.form-group').after('<p class="warning-danger w-100 mt-2 fs-13">Enter a valid phone number</p>');
                setTimeout(() => {
                $('.warning-danger').slideUp(500, 'linear', () => $(this).remove());
                }, 2000);
                return;
            }
        }

        if (paymentType === "Installments") {
            const totalDue = installments.reduce((sum, inst) => sum + (parseFloat(inst.dueAmount) || 0), 0);
            if (totalDue !== parseFloat(salePrice)) {
                setIsError(true);
                setIsSuccess(false);
                setMessage("Installment total must equal Sale Price.");

                setTimeout(() => {
                    setIsError(false);
                    setMessage("");
                }, 5000);

                return;
            }
        }

        const numericAmountReceived = parseFloat(amountReceived);
        const numericSalePrice = parseFloat(salePrice || 0);

        if ((paymentType === "Full Payment" && (isNaN(numericAmountReceived) || numericAmountReceived !== numericSalePrice)) || 
        (paymentType === "Down Payment" && (isNaN(numericAmountReceived) || numericAmountReceived === numericSalePrice))) {
            setIsError(true);
            setIsSuccess(false);
            setMessage(
                paymentType === "Full Payment"
                ? "Received amount must equal Sale Price for Full Payment."
                : "Received amount cannot equal Sale Price for Down Payment."
            );

            setTimeout(() => {
                setIsError(false);
                setMessage("");
            }, 5000);

            return;
        }
    
        const payload = {
            enrollment_email: learnerDetails.enrollmentEmail,
            lead_email: learnerDetails.leadEmail,
            payment_email: learnerDetails.paymentEmail,
            phone_number: learnerDetails.phoneNumber,
            country_code: country_code,
            secondary_phone_number: learnerDetails.secondaryPhoneNumber,
            secondary_country_code: learnerDetails.secondaryPhoneNumber ? secondary_country_code : '',
            country: learnerDetails.country,
            state: learnerDetails.state,
            full_name: learnerDetails.name,
            is_business: learnerDetails.isBusiness,
            gst_number: learnerDetails.gstNumber,
            company_name: learnerDetails.companyName,
            registered_company_address: learnerDetails.companyAddress,
    
            program: program,
            offer_type: parseInt(offerType),
            sale_owner_email: saleOwnerEmail,
            team_lead_email: teamLeadEmail,
            sale_price: parseFloat(salePrice),
            program_mrp: parseFloat(mrp),
            discount_price: parseFloat(discount),
            currency: currency,
    
            payment_type: paymentType.toLowerCase().replace(" ", "_"),

            ...(selectedOfferName === "BOGO" && {bogo_program: parseInt(BOGOProgram)}),

            ...((validityOption === "custom") && (paymentType !== "Full Payment") && {custom_validity_days: parseInt(accessDays, 10)}),

            ...(paymentType !== "Installments" && {amount_received: parseFloat(amountReceived), payment_date: paymentDate, payment_gateway: paymentGateway, transaction_id: transactionId, start_date: accessStartDate, expiry_date: accessEndDate, validity: validityOption}),

            ...(paymentType === "Down Payment" && {loan_amount: parseFloat(loanDetails.loanAmount), loan_partner: loanDetails.loanPartner, loan_status: loanDetails.loanStatus}),

            ...(paymentType === "Installments" && {
                all_installments: installments.map((inst, idx) => ({
                    installment_number: `installment_${idx + 1}`,
                    due_amount: parseFloat(inst.dueAmount),
                    installment_status: inst.status.toLowerCase(),
                    next_emi_date: inst.dueDate,
                    ...(inst.status === "received" && 
                        {
                            amount_received: parseFloat(inst.receivedInstallmentAmount), 
                            payment_date: inst.paymentDate, 
                            transaction_id: inst.transactionId, 
                            payment_gateway: inst.paymentGateway,
                            start_date: inst.startDate,
                            expiry_date: inst.expiryDate,
                            validity: inst.validityOption,
                            ...(inst.validity === "custom" && {custom_validity_days: parseInt(inst.accessDays, 10)})
                        }),
                }))
            })
        };

        console.log("Payload for API:", payload);
    
        try {
            const response = await fetch(identity_host+'/centralized/program/sale/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrf,
                },
                credentials: process.env.REACT_APP_CREDENTIAL_TYPE,
                body: JSON.stringify(payload),
            });
    
            const data = await response.json();

            if (!response.ok) {
                setIsError(true);
                setMessage(data.error || "Network response was not ok!");
                setTimeout(() => {
                    setIsError(false);
                    setMessage("");
                }, 5000);
                // resetForm();
                return false;
            } else {
                if (data.error) {
                    setIsError(true);
                    setMessage(data.error || "Something went wrong!");
                    setTimeout(() => {
                        setIsError(false);
                        setMessage("");
                    }, 5000);
                } else {
                    setIsSuccess(true);
                    setMessage(data.response || "Sale created successfully!");
                    setTimeout(() => {
                        setIsSuccess(false);
                        setMessage("");
                    }, 5000);
                    resetForm();
                }
            }
        } catch (error) {
            console.error('Error creating sale:', error);
            setIsError(true);
            setMessage(error.message);
            setTimeout(() => {
                setIsError(false);
                setMessage("");
            }, 5000);
        }
    };    

    // Derived data for countries, states, currencies, and payment types.
    const countries = Country.getAllCountries().map((country) => ({
        label: country.name,
        value: country.isoCode,
    }));

    const states = learnerDetails.countryCode ? State.getStatesOfCountry(learnerDetails.countryCode).map((state) => state.name) : [];

    const currencies = currencyCodes.data.map((currency) => ({
        label: `${currency.currency} (${currency.code})`,
        value: currency.code,
    }));

    // Ensure expiry date is calculated on component load if accessStartDate is set
    useEffect(() => {
        if (accessStartDate && accessDays) {
            const expiryDate = addDays(new Date(accessStartDate), parseInt(accessDays, 10));
            setAccessEndDate(expiryDate.toISOString().split('T')[0]);
        }
    }, [accessStartDate, accessDays]);

    // Function to reset the form
    const resetForm = () => {
        setLearnerDetails({ 
          name: "",
          leadEmail: "",
          enrollmentEmail: "",
          enrollmentEmailAsLeadEmail: false,
          paymentEmailAsLeadEmail: false,
          phoneNumber: "",
          secondaryPhoneNumber: "",
          country: "India",
          countryCode: "IN",
          state: "",
          paymentEmail: "",
          isBusiness: false,
          gstNumber: "",
          companyName: "",
          companyAddress: ""
        });
      
        setPaymentType("");
        setProgram("");
        setBOGOProgram("");
        setSalePrice("");
        setDiscount("");
        setOfferType("");
        setSaleOwnerEmail("");
        setTeamLeadEmail("");
        setAccessStartDate("");
        setAccessEndDate(""); 
        setMrp("");
        setTransactionId("");
        setPaymentGateway("");
        setPaymentDate("");
        setAccessDays(7);
        setCurrency("USD");
        setAmountReceived("");
        setSalePriceError("");
        setReceivedAmountError("");
        setStartDateError("");
        setExpiryDateError("");
        setValidityOption("7_days");
      
        setInstallments([
          { 
            id: 1, 
            installment_number: "installment_1",
            dueAmount: "", 
            dueDate: "", 
            status: "received",  
            receivedInstallmentAmount: "",
            paymentDate: "",
            transactionId: "",
            paymentGateway: "",
            startDate: "",
            expiryDate: "",
            validityOption: "7_days",
            accessDays: 7,
            expiryDateError: "",
            startDateError: "",
            dueAmountError: "",
            receivedAmountError: ""
          }
        ]);
      
        setLoanDetails({
          loanPartner: "",
          loanAmount: "",
          loanStatus: "pending"
        });

      };      

    return (
        <>
        {iserror && <ErrorAlert message={message} setIsError={setIsError} />}
        {issuccess && <SuccessAlert message={message} setIsSuccess={setIsSuccess} />}
        <form onSubmit={createSale}>
            <div className='card p-4 border-0 shadow background-dark-secondary mb-4'>
                <div className="card-body">
                    <h2 className='text-white fs-20 mb-3'>Learner Details</h2>
                    <div className='row'>
                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">Name <sup className='text-danger'>*</sup></label>
                                <input 
                                type="text" 
                                className='form-control background-dark-tertiary' 
                                value={learnerDetails.name}
                                onChange={(event)=>setLearnerDetails({...learnerDetails,name:event.target.value})}
                                required
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">Primary Contact Number <sup className='text-danger'>*</sup></label>
                                <input 
                                type="tel" 
                                id='phoneNumber'
                                className='form-control background-dark-tertiary'
                                value={learnerDetails.phoneNumber}
                                onChange={(event)=>setLearnerDetails({...learnerDetails,phoneNumber:event.target.value})}
                                required
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">Secondary Contact Number</label>
                                <input 
                                type="tel" 
                                id='secondaryPhoneNumber'
                                className='form-control background-dark-tertiary'
                                value={learnerDetails.secondaryPhoneNumber}
                                onChange={(event)=>setLearnerDetails({...learnerDetails,secondaryPhoneNumber:event.target.value})}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">Lead Email <sup className='text-danger'>*</sup></label>
                                <input 
                                type="email" 
                                id='leadEmail'
                                className='form-control background-dark-tertiary' 
                                value={learnerDetails.leadEmail}
                                onChange={(event)=>setLearnerDetails({...learnerDetails,leadEmail:event.target.value})}
                                required
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group mb-2">
                                <label className="text-white mb-2">Payment Email <sup className='text-danger'>*</sup></label>
                                <input 
                                type="email" 
                                id='paymentEmail'
                                className='form-control background-dark-tertiary'
                                value={learnerDetails.paymentEmailAsLeadEmail ? learnerDetails.leadEmail : learnerDetails.paymentEmail}
                                onChange={(event) => setLearnerDetails({...learnerDetails,paymentEmail:event.target.value})}
                                disabled={learnerDetails.paymentEmailAsLeadEmail}
                                required
                                />
                            </div>
                            <div className="form-check mb-3">
                                <input className="form-check-input" type="checkbox" value="setPaymentEmail" id='paymentCheckbox' checked={learnerDetails.paymentEmailAsLeadEmail} onChange={(e)=>{setLearnerDetails({...learnerDetails,paymentEmailAsLeadEmail:e.target.checked,paymentEmail:e.target.checked?learnerDetails.leadEmail:learnerDetails.paymentEmail})}} />
                                <label className="form-check-label text-white" htmlFor="paymentCheckbox">
                                    Same as Lead Email
                                </label>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group mb-2">
                                <label className="text-white mb-2">Enrollment Email <sup className='text-danger'>*</sup></label>
                                <input 
                                type="email" 
                                id="enrollmentEmail"
                                className='form-control background-dark-tertiary'
                                value={(learnerDetails.enrollmentEmailAsLeadEmail ? learnerDetails.leadEmail : learnerDetails.enrollmentEmail)}
                                onChange={(event) => setLearnerDetails({...learnerDetails,enrollmentEmail:event.target.value})}
                                disabled={learnerDetails.enrollmentEmailAsLeadEmail}
                                required
                                />
                            </div>
                            <div className="form-check mb-3">
                                <input className="form-check-input" type="checkbox" value="setEnrollmentEmail" id='enrollmentCheckbox' checked={learnerDetails.enrollmentEmailAsLeadEmail} onChange={(e)=>{setLearnerDetails({...learnerDetails,enrollmentEmailAsLeadEmail:e.target.checked,enrollmentEmail:e.target.checked?learnerDetails.leadEmail:learnerDetails.enrollmentEmail})}} />
                                <label className="form-check-label text-white" htmlFor="enrollmentCheckbox">
                                    Same as Lead Email
                                </label>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">Country</label>
                                <select
                                className="form-select background-dark-tertiary"
                                value={`${learnerDetails.country}:${learnerDetails.countryCode}`}
                                onChange={(e) => {
                                    const [country, countryCode] = e.target.value.split(':');
                                    setLearnerDetails({...learnerDetails, country, countryCode, state: '' });
                                }}
                                required
                                >
                                <option value="" disabled>Select Country</option>
                                {countries?.map((country) => (
                                    <option value={`${country.label}:${country.value}`} key={country.value}>
                                    {country.label}
                                    </option>
                                ))}
                                </select>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">State {learnerDetails.country === 'India' && <sup className='text-danger'>*</sup>}</label>
                                <select
                                className="form-select background-dark-tertiary"
                                value={learnerDetails.state}
                                onChange={(e) => setLearnerDetails({...learnerDetails,state: e.target.value })}
                                disabled={learnerDetails.country !== 'India'}
                                required={learnerDetails.country === 'India'}
                                >
                                <option value="" disabled>Select State</option>
                                {learnerDetails.country === 'India' &&
                                    states?.map((state) => (
                                    <option value={state} key={state}>
                                        {state}
                                    </option>
                                    ))}
                                {learnerDetails.country === 'India' && <option value="Unknown">Unknown</option>}
                                </select>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="form-check mb-3">
                                <input className="form-check-input" type="checkbox" id='isBusiness' checked={learnerDetails.isBusiness} onChange={(e) => setLearnerDetails({...learnerDetails,isBusiness:e.target.checked})}/>
                                <label className="form-check-label text-white" htmlFor="isBusiness">Is a business?</label>
                            </div>
                        </div>

                        {learnerDetails.isBusiness && (
                            <>
                                <div className="col-6">
                                    <div className="form-group mb-3">
                                        <label className="text-white mb-2">GST Number <sup className='text-danger'>*</sup></label>
                                        <input
                                        type="text"
                                        className="form-control background-dark-tertiary"
                                        value={learnerDetails.gstNumber}
                                        onChange={(e) => setLearnerDetails({...learnerDetails,gstNumber:e.target.value})}
                                        required={learnerDetails.isBusiness}
                                        />
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="form-group mb-3">
                                        <label className="text-white mb-2">Company Name <sup className='text-danger'>*</sup></label>
                                        <input
                                        type="text"
                                        className="form-control background-dark-tertiary"
                                        value={learnerDetails.companyName}
                                        onChange={(e) => setLearnerDetails({...learnerDetails,companyName:e.target.value})}
                                        required={learnerDetails.isBusiness}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group mb-3">
                                        <label className="text-white mb-2">Registered Company Address <sup className='text-danger'>*</sup></label>
                                        <textarea
                                        className="form-control background-dark-tertiary"
                                        rows="3"
                                        value={learnerDetails.companyAddress}
                                        onChange={(e) => setLearnerDetails({...learnerDetails,companyAddress:e.target.value})}
                                        required={learnerDetails.isBusiness}
                                        ></textarea>
                                    </div>
                                </div>
                            </>
                        )}

                    </div>
                </div>
            </div>
            <div className="card p-4 border-0 shadow background-dark-secondary mb-4">
                <div className="card-body">
                    <h2 className='text-white fs-20 mb-3'>Payment & Contact details</h2>
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">Program Name <sup className='text-danger'>*</sup></label>
                                <select
                                    className="form-select background-dark-tertiary"
                                    value={program}
                                    onChange={(e) => {
                                        const [id, country] = e.target.value.split('-');
                                        const selected = saleContext.programs.find(p => p.id.toString() === id);

                                        setProgram(e.target.value);
                                        setMrp(
                                        selected ? {
                                            India: selected.price_inr,
                                            'US/Canada': selected.price_usd,
                                            ROW: selected.price_row,
                                        }[country] || '' : ''
                                        );
                                    }}
                                    required
                                    >
                                    <option value="" disabled>Select Program</option>
                                    {saleContext?.programs?.flatMap(program =>
                                        saleContext.country_group_choices.map(group => (
                                        <option value={`${program.id}-${group}`} key={`${program.id}-${group}`}>
                                            {program.name}-{group}
                                        </option>
                                        ))
                                    )}
                                </select>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">MRP Currency <sup className='text-danger'>*</sup></label>
                                <select 
                                    className="form-select background-dark-tertiary" 
                                    value={currency} 
                                    onChange={(e) => setCurrency(e.target.value)} 
                                    required
                                >
                                    <option value="" disabled>Select Currency</option>
                                    {currencies.map((currency) => (
                                        <option key={currency.value} value={currency.value}>
                                            {currency.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">MRP <sup className='text-danger'>*</sup></label>
                                <input 
                                    type="text" 
                                    className='form-control background-dark-tertiary' 
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={mrp}
                                    onChange={(event) => handleMrpChange(event.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">Sale Price <sup className='text-danger'>*</sup></label>
                                <input 
                                    type="text" 
                                    className='form-control background-dark-tertiary' 
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={salePrice}
                                    onChange={(event) => handleSalePriceChange(event.target.value)}
                                    disabled={!mrp}
                                    required
                                />
                                {salePriceError && (
                                    <small className="text-danger">{salePriceError}</small>
                                )}
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">Discount</label>
                                <input 
                                    type="text"
                                    className='form-control background-dark-tertiary' 
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={discount}
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">Offer {parseFloat(discount)>0 && <sup className='text-danger'>*</sup>}</label>
                                <select className="form-select background-dark-tertiary" value={offerType} onChange={(e)=>{setOfferType(e.target.value)}} required={parseFloat(discount)>0}>
                                <option value="" disabled>Select Offer Type</option>
                                {saleContext?.offer_type?.map((offer)=>{
                                    return(<option value={offer.id} key={offer.id}>{offer.name}</option>)
                                })}
                                </select>
                            </div>
                        </div>
                        {selectedOfferName === 'BOGO' && <div className='col-12'>
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">BOGO Program Name <sup className='text-danger'>*</sup></label>
                                <select
                                    className="form-select background-dark-tertiary"
                                    value={BOGOProgram}
                                    onChange={(e) => {setBOGOProgram(e.target.value)}}
                                    required
                                    >
                                    <option value="" disabled>Select BOGO Program</option>
                                    {saleContext?.programs?.map(program => (
                                        <option value={`${program.id}`} key={program.id}>
                                            {program.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>}
                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">Payment Type <sup className='text-danger'>*</sup></label>
                                <select 
                                    className="form-select background-dark-tertiary" 
                                    value={paymentType} 
                                    onChange={(e) => setPaymentType(e.target.value)} 
                                    required
                                >
                                    <option value="" disabled>Select Payment Type</option>
                                    {paymentTypeOptions.map((type) => (
                                        <option key={type} value={type}  disabled={['50% Scholarship', '100% Scholarship'].includes(selectedOfferName) && type === 'Down Payment'}>
                                            {type}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {(paymentType !== "Installments") && <>
                            <div className="col-6">
                                <div className="form-group mb-3">                            
                                    <label className="text-white mb-2">Payment Date <sup className='text-danger'>*</sup></label>
                                    <input 
                                    className='form-control background-dark-tertiary'
                                    type="date" 
                                    value={paymentDate}
                                    onChange={(event)=>setPaymentDate(event.target.value)}
                                    required={paymentType !== "Installments"}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label className="text-white mb-2">Received Amount <sup className='text-danger'>*</sup></label>
                                    <input 
                                        type="text" 
                                        className='form-control background-dark-tertiary'
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        value={amountReceived}
                                        onChange={(event) => handleReceivedAmountChange(event.target.value)}
                                        required={paymentType !== "Installments"}
                                    />
                                    {receivedAmountError && (
                                        <small className="text-danger">{receivedAmountError}</small>
                                    )}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label className="text-white mb-2">Start Date <sup className='text-danger'>*</sup></label>
                                    <input 
                                        type="date" 
                                        className='form-control background-dark-tertiary' 
                                        value={accessStartDate}
                                        onChange={(event) => handleStartDateChange(event.target.value)}
                                        required={paymentType !== "Installments"}
                                    />
                                    {startDateError && <small className="text-danger">{startDateError}</small>}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label className="text-white mb-2">Validity <sup className='text-danger'>*</sup></label>
                                    <select 
                                        className="form-select background-dark-tertiary" 
                                        value={validityOption} 
                                        onChange={(e) => handleValidityChange(e.target.value)} 
                                        required={paymentType !== "Installments"}
                                    >
                                        <option value="7_days">7 days</option>
                                        <option value="1_month">1 Month</option>
                                        <option value="full_access">Full Access</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label className="text-white mb-2">Expiry Date <sup className='text-danger'>*</sup></label>
                                    <input 
                                        type="date" 
                                        className='form-control background-dark-tertiary'
                                        value={accessEndDate}
                                        onChange={(event) => handleExpiryDateChange(event.target.value)}
                                        required={paymentType !== "Installments"}
                                    />
                                    {expiryDateError && <small className="text-danger">{expiryDateError}</small>}
                                </div>
                            </div>
                            {validityOption === "custom" && (
                                <div className="col-6">
                                    <div className="form-group mb-3">
                                        <label className="text-white mb-2">Custom Validity (in days)</label>
                                        <input 
                                            type="number" 
                                            className='form-control background-dark-tertiary' 
                                            value={accessDays}
                                            onChange={(event) => {
                                                setAccessDays(event.target.value);
                                                if (accessStartDate && event.target.value) {
                                                    const expiryDate = addDays(new Date(accessStartDate), parseInt(event.target.value, 10));
                                                    setAccessEndDate(expiryDate.toISOString().split('T')[0]);
                                                } else {
                                                    setAccessEndDate("");
                                                }
                                            }}
                                            min={1}
                                            required={(validityOption === "custom") && (paymentType !== "Installments")} 
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label className="text-white mb-2">Payment Gateway <sup className='text-danger'>*</sup></label>
                                    <select className="form-select background-dark-tertiary" value={paymentGateway} onChange={(e)=>{setPaymentGateway(e.target.value)}} required={paymentType !== "Installments"}>
                                    <option value="" disabled>Select Payment Gateway</option>
                                    {saleContext?.payment_gateways?.map((obj)=>{
                                        return(<option value={obj.id} key={obj.id}>{obj.name}</option>)
                                    })}
                                    </select>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label className="text-white mb-2">Revenue Center</label>
                                    <input 
                                        type="text" 
                                        className='form-control background-dark-tertiary'
                                        value={saleContext?.payment_gateways?.find((gw) => gw.id === parseInt(paymentGateway))?.company?.name || ""}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label className="text-white mb-2">Transaction Id <sup className='text-danger'>*</sup></label>
                                    <input 
                                    type="text" 
                                    className='form-control background-dark-tertiary' 
                                    value={transactionId}
                                    onChange={(event)=>setTransactionId(event.target.value)}
                                    required={paymentType !== "Installments"}
                                    />
                                </div>
                            </div>
                        </>}
                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">Sale Owner <sup className='text-danger'>*</sup></label>
                                <select className="form-select background-dark-tertiary" value={saleOwnerEmail} onChange={(e)=>{setSaleOwnerEmail(e.target.value)}} required>
                                <option value="" disabled>Select Sale Owner</option>
                                {saleContext?.learning_counselors?.map((counselor)=>{
                                    return(<option key={counselor.id} value={counselor.email}>{counselor.email}</option>)
                                })}
                                </select>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group mb-3">
                                <label className="text-white mb-2">TL <sup className='text-danger'>*</sup></label>
                                <select className="form-select background-dark-tertiary" value={teamLeadEmail} onChange={(event)=>setTeamLeadEmail(event.target.value)} required>
                                <option value="" disabled>Select TL</option>
                                {saleContext?.learning_counselors?.filter((counselor) => counselor.is_team_lead).map((counselor)=>{
                                    return(<option key={counselor.id} value={counselor.email}>{counselor.email}</option>)
                                })}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {paymentType === "Installments" && (
                <div className="card p-4 border-0 shadow background-dark-secondary">
                    <div className="card-body">
                        <h2 className='text-white fs-20 mb-3'>Installment Details</h2>
                        {installments.map((installment, index) => (
                            <div key={installment.id} className="mb-4">
                                <h3 className='text-white fs-18 mb-3'>Installment {index + 1}</h3>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group mb-3">
                                            <label className="text-white mb-2">Installment Due Amount <sup className='text-danger'>*</sup></label>
                                            <input
                                                type="text"
                                                className="form-control background-dark-tertiary"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                value={installment.dueAmount}
                                                onChange={(e) => updateInstallment(index, "dueAmount", e.target.value)}
                                                required={paymentType === "Installments"}
                                            />
                                            {installment.dueAmountError && <small className="text-danger">{installment.dueAmountError}</small>}
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group mb-3">
                                            <label className="text-white mb-2">Installment Due Date <sup className='text-danger'>*</sup></label>
                                            <input
                                                type="date"
                                                className="form-control background-dark-tertiary"
                                                value={installment.dueDate}
                                                onChange={(e) => updateInstallment(index, "dueDate", e.target.value)}
                                                required={paymentType === "Installments"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group mb-3">
                                            <label className="text-white mb-2">Installment Status <sup className='text-danger'>*</sup></label>
                                            <select
                                                className="form-select background-dark-tertiary"
                                                value={installment.status}
                                                onChange={(e) => updateInstallment(index, "status", e.target.value)}
                                                required={paymentType === "Installments"}
                                                disabled={index === 0}
                                            >
                                                <option value="" disabled>Select Status</option>
                                                <option value="received">Received</option>
                                                <option value="due">Due</option>
                                                <option value="past_due">Past Due</option>
                                            </select>
                                        </div>
                                    </div>
                                    {installment.status === "received" && (
                                        <>
                                            <div className="col-6">
                                                <div className="form-group mb-3">
                                                    <label className="text-white mb-2">Received Amount <sup className='text-danger'>*</sup></label>
                                                    <input
                                                        type="text"
                                                        className="form-control background-dark-tertiary"
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                        value={installment.receivedInstallmentAmount}
                                                        onChange={(e) => updateInstallment(index, "receivedInstallmentAmount", e.target.value)}
                                                        required={(paymentType === "Installments") && (installment.status === "received")}
                                                    />
                                                    {installment.receivedAmountError && <small className="text-danger">{installment.receivedAmountError}</small>}
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group mb-3">
                                                    <label className="text-white mb-2">Payment Date <sup className='text-danger'>*</sup></label>
                                                    <input
                                                        type="date"
                                                        className="form-control background-dark-tertiary"
                                                        value={installment.paymentDate}
                                                        onChange={(e) => updateInstallment(index, "paymentDate", e.target.value)}
                                                        required={(paymentType === "Installments") && (installment.status === "received")}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group mb-3">
                                                    <label className="text-white mb-2">Transaction ID <sup className='text-danger'>*</sup></label>
                                                    <input
                                                        type="text"
                                                        className="form-control background-dark-tertiary"
                                                        value={installment.transactionId}
                                                        onChange={(e) => updateInstallment(index, "transactionId", e.target.value)}
                                                        required={(paymentType === "Installments") && (installment.status === "received")}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group mb-3">
                                                    <label className="text-white mb-2">Payment Gateway <sup className='text-danger'>*</sup></label>
                                                    <select
                                                        className="form-select background-dark-tertiary"
                                                        value={installment.paymentGateway}
                                                        onChange={(e) => updateInstallment(index, "paymentGateway", e.target.value)}
                                                        required={(paymentType === "Installments") && (installment.status === "received")}
                                                    >
                                                        <option value="" disabled>Select Payment Gateway</option>
                                                        {saleContext?.payment_gateways?.map((gateway) => (
                                                            <option key={gateway.id} value={gateway.id}>
                                                                {gateway.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group mb-3">
                                                    <label className="text-white mb-2">Revenue Center</label>
                                                    <input 
                                                        type="text" 
                                                        className='form-control background-dark-tertiary'
                                                        value={saleContext?.payment_gateways?.find((gw) => gw.id === parseInt(installment.paymentGateway))?.company?.name || ""}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group mb-3">
                                                    <label className="text-white mb-2">Start Date <sup className='text-danger'>*</sup></label>
                                                    <input 
                                                        type="date" 
                                                        className='form-control background-dark-tertiary' 
                                                        value={installment.startDate}
                                                        onChange={(event) => updateInstallment(index, "startDate", event.target.value)}
                                                        required={(paymentType === "Installments") && (installment.status === "received")}
                                                    />
                                                    {installment.startDateError && <small className="text-danger">{installment.startDateError}</small>}
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group mb-3">
                                                    <label className="text-white mb-2">Validity <sup className='text-danger'>*</sup></label>
                                                    <select 
                                                        className="form-select background-dark-tertiary" 
                                                        value={installment.validityOption} 
                                                        onChange={(e) => updateInstallment(index, "validityOption", e.target.value)} 
                                                        required={(paymentType === "Installments") && (installment.status === "received")}
                                                    >
                                                        <option value="7_days">7 days</option>
                                                        <option value="1_month">1 Month</option>
                                                        <option value="full_access">Full Access</option>
                                                        <option value="custom">Custom</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group mb-3">
                                                    <label className="text-white mb-2">Expiry Date <sup className='text-danger'>*</sup></label>
                                                    <input 
                                                        type="date" 
                                                        className='form-control background-dark-tertiary'
                                                        value={installment.expiryDate}
                                                        onChange={(event) => updateInstallment(index, "expiryDate", event.target.value)}
                                                        required={(paymentType === "Installments") && (installment.status === "received")}
                                                    />
                                                    {installment.expiryDateError && <small className="text-danger">{installment.expiryDateError}</small>}
                                                </div>
                                            </div>
                                            {installment.validityOption === "custom" && (
                                                <div className="col-6">
                                                    <div className="form-group mb-3">
                                                        <label className="text-white mb-2">Custom Validity (in days)</label>
                                                        <input 
                                                            type="number" 
                                                            className='form-control background-dark-tertiary' 
                                                            value={installment.accessDays}
                                                            onChange={(event) => updateInstallment(index, "accessDays", event.target.value)}
                                                            min={1}
                                                            required={(installment.validityOption === "custom") && (paymentType === "Installments") && (installment.status === "received")} 
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                                {installments.length > 1 && (
                                    <button
                                        type="button"
                                        className="btn btn-dark btn-dark-primary px-4 py-2 mt-3 fw-bold"
                                        onClick={() => removeInstallment(index)}
                                    >
                                        Remove Installment
                                    </button>
                                )}
                            </div>
                        ))}
                        <button
                            type="button"
                            className="btn btn-dark btn-dark-primary px-4 py-2 mt-3 fw-bold"
                            onClick={addInstallment}
                        >
                            Add Installment
                        </button>
                    </div>
                </div>
            )}
            {paymentType === "Down Payment" && (
                <div className="card p-4 border-0 shadow background-dark-secondary mb-4">
                    <div className="card-body">
                        <h2 className='text-white fs-20 mb-3'>Loan Details</h2>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label className="text-white mb-2">Loan Partner <sup className='text-danger'>*</sup></label>
                                    <select
                                        className="form-select background-dark-tertiary"
                                        value={loanDetails.loanPartner}
                                        onChange={(e) => setLoanDetails(prev => ({...prev,loanPartner:e.target.value}))}
                                        required={paymentType === "Down Payment"}
                                    >
                                        <option value="" disabled>Select Loan Partner</option>
                                        {saleContext?.loan_partners?.map((partner) => (
                                            <option key={partner.id} value={partner.id}>
                                                {partner.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label className="text-white mb-2">Loan Amount <sup className='text-danger'>*</sup></label>
                                    <input 
                                        type="text" 
                                        className='form-control background-dark-tertiary'
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        value={loanDetails.loanAmount}
                                        onChange={(e) => setLoanDetails(prev => ({...prev,loanAmount:e.target.value}))}
                                        required={paymentType === "Down Payment"}
                                        readOnly    
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group mb-3">
                                    <label className="text-white mb-2">Loan Status <sup className='text-danger'>*</sup></label>
                                    <select 
                                        className="form-select background-dark-tertiary"
                                        value={loanDetails.loanStatus}
                                        onChange={(e) => setLoanDetails(prev => ({...prev,loanStatus: e.target.value}))}
                                        required={paymentType === "Down Payment"}
                                        readOnly
                                        disabled
                                    >
                                        <option value="pending">In Progress</option>
                                        {/* <option value="approved">Approved</option>
                                        <option value="rejected">Rejected</option> */}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="d-flex gap-3 mt-3">
                <button type="submit" className='btn btn-dark btn-dark-primary px-5 py-2 mt-3 fw-bold ms-auto'>
                    Submit Sale
                </button>
                <button onClick={resetForm} type="button" className='btn btn-dark btn-dark-primary px-5 py-2 mt-3 fw-bold'>
                    Clear
                </button>
            </div>
        </form>
        </>
    );
}

const mapStateToProps = (state) => ({
    csrf: state.LoginModalReducer.csrf,
    islogin: state.LoginModalReducer.islogin,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(IndividualSale);
